import { render, staticRenderFns } from "./HeaderConstructor.vue?vue&type=template&id=68ced624"
import script from "./HeaderConstructor.vue?vue&type=script&lang=js"
export * from "./HeaderConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports